<template>
  <div :class="setClass">
    <div class="icon-bg">
      <img v-if="words == 'Where to Stay'" src="/images/icons/bed.svg" class="icon" />
      <img v-if="words == 'What to See & Do'" src="/images/icons/binocular.svg" class="icon" />
      <img v-if="words == 'Where to Eat'" src="/images/icons/food.svg" class="icon" />
    </div>
    <h2>{{ words }}</h2>
    <div class="destination-wrapper">
      <b-carousel controls indicators img-width="480" img-height="400" :interval="interval">
        <b-carousel-slide
          v-for="item in items"
          :key="item.id"
          :style="imageStyle(item.imageUrl, defaultImage)"
        >
          <UserFavorite
            v-if="!item.eventDate"
            :myTrips="myTrips"
            :objectid="item.id"
            :favorite="isFavorite(item.id)"
            :slug="item.slug"
            :isCarousel="isCarousel"
          />
          <router-link :to="getLink(item)"></router-link>
          <div class="no-map">
            <h3>{{ item.name }}</h3>
            <div v-if="item.summary && item.summary.length <= 250" class="small">
              {{ item.summary }}
            </div>
            <div v-else-if="item.summary" class="small">
              {{ item.summary.substring(0, 250) }}...
            </div>
            <br />

            <router-link :to="getLink(item)" class="view-link">
              <h3 class="view">View <span class="arrow">⤳</span></h3></router-link
            >
          </div>
        </b-carousel-slide>
      </b-carousel>
    </div>
  </div>
</template>
<script>
import UserFavorite from '@/components/Common/UserFavorite.vue';

export default {
  name: 'places-to-go-carousel',
  components: {
    UserFavorite,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    words: {
      type: String,
    },
    defaultImage: {
      type: String,
    },
    sliderCount: {
      type: Number,
    },
    myTrips: {
      type: Array,
    },
  },
  data() {
    return {
      isCarousel: true,
      interval: 5000,
    };
  },
  created() {
    this.$root.$on('toggleCarouselInterval', (value) => {
      this.interval = value;
    });
    this.$root.$on('afterSignIn', (value) => {
      this.$props.myTrips = value;
      this.$root.$emit('toggleCarouselInterval', 5000);
    });
  },
  methods: {
    isFavorite(objectid) {
      return this.$store.getters['favorites/isFavorite'](objectid);
    },
    imageStyle(imageUrl, defaultImage) {
      if (imageUrl) {
        return `background-image : url(${imageUrl.replace(/\s/g, '+')})`;
      }
      return `background-image : url(${defaultImage})`;
    },
    getLink(item) {
      if (item.startDate) {
        return `/upcoming-events/${item.slug}`;
      }
      return `/places-to-go/${item.slug}`;
    },
  },
  computed: {
    setClass() {
      switch (this.sliderCount) {
        case 1:
          return 'col-one';
        case 2:
          return 'col-two';
        default:
          return 'col-four';
      }
    },
  },
};
</script>

<style scoped>
h1 {
  font-family: 'klinicslabbold';
  font-size: 2rem;
  color: #173945;
}

.col-one {
  grid-column: 5 / span 4;
  @media only screen and (max-width: 998px) {
    grid-column: 1 / span 1;
  }
}
.col-two {
  grid-column: span 4;
  @media only screen and (max-width: 998px) {
    grid-column: 1 / span 1;
  }
}

.col-four {
  grid-column: span 4 / span 4;
  @media only screen and (max-width: 998px) {
    grid-column: span 1 / span 1;
  }
}
.carousel {
  height: 100%;
}
.destination-wrapper >>> .carousel-indicators {
  bottom: 275px;
}

.carousel-caption > .fav-wrapper {
  left: 0px;
  z-index: 9999;
}

.carousel-item {
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center !important;
  border-radius: var(--spacing-xs);
  min-height: 400px;
  /* Set slide height here */
  width: 100% !important;
  position: relative;
  @media only screen and (max-width: 768px) {
    border-radius: 0;
  }
}

.destination-wrapper >>> .carousel-inner {
  overflow-y: visible !important;
  min-height: 666px;
}
.carousel-inner {
  overflow: visible !important;
}

.destination-wrapper >>> .carousel-caption {
  padding-bottom: 170px !important;
  min-height: 400px !important;
}

.destination-wrapper >>> .carousel-control-prev,
.destination-wrapper >>> .carousel-control-next {
  height: 200px;
  margin-top: 100px;
  opacity: 1;
  width: 55px;
}

.destination-wrapper >>> .carousel-control-next-icon,
.destination-wrapper >>> .carousel-control-prev-icon {
  background-image: none;
  height: 120px;
}

.destination-wrapper >>> a.carousel-control-prev,
.destination-wrapper >>> a.carousel-control-next {
  z-index: 99;
  color: #ccc;
  background-image: none;
}

.destination-wrapper >>> a:hover.carousel-control-prev,
.destination-wrapper >>> a:active.carousel-control-prev,
.destination-wrapper >>> a:hover.carousel-control-next,
.destination-wrapper >>> a:active.carousel-control-next {
  color: #357e99;
}

.destination-wrapper >>> .carousel-control-prev-icon:before {
  font-family: 'icomoon';
  content: '\e902';
  font-size: 4.5rem;
}

.destination-wrapper >>> .carousel-control-next-icon:before {
  font-family: 'icomoon';
  content: '\e903';
  font-size: 4.5rem;
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #ccc;
  opacity: 1;
}

.destination-wrapper {
  height: 666px;
}

.destination-wrapper >>> .carousel-caption {
  position: relative;
  right: 0px;
  top: 10px;
  bottom: 0px;
  left: 0px;
  z-index: 10;
  padding-top: 0px;
  padding-bottom: 0px;
  color: #173945;
  text-align: left;
}

.destination-wrapper >>> .carousel-caption .no-map {
  width: 100%;
  padding: 0 2em 0 2em;
  position: absolute;
  top: 415px;
}

.destination-wrapper >>> .carousel-caption h1 {
  font-size: 2.5rem;
  line-height: 2.5rem;
}

.destination-wrapper >>> .destination-wrapper button {
  top: 20px;
  left: 0px;
  position: absolute;
  z-index: 100;
}

.destination-wrapper >>> .carousel-item {
  position: relative;
}

.destination-wrapper >>> .carousel-item img {
  padding-bottom: 150px;
  border-left: solid 5px #fff;
}

.destination-wrapper >>> .carousel-indicators li {
  background-color: #d8d8d8;
  border: 2px solid #4e97b2;
  border-radius: 50%;
  height: 20px;
  margin-left: 3px;
  margin-right: 3px;
  width: 20px;
}

.destination-wrapper >>> .carousel-indicators .active {
  opacity: 1;
  background-color: #4e97b2;
}

.destination-wrapper >>> .carousel-caption a {
  display: block;
  position: absolute;
  top: -10px;
  right: 0px;
  left: 0px;
  bottom: -90px;
  z-index: 1;
}
.destination-wrapper >>> .carousel-caption .view-link {
  position: relative;
}

.icon-bg {
  background-color: #dbf0f3;
  border-radius: 100%;
  border: solid 1px #0a4850;
  width: 60px;
  height: 60px;
  margin: 0 auto 1rem auto;
  position: relative;
}

.icon {
  position: absolute;
  top: 30%;
  bottom: 50%;
  left: 25%;
  right: 50%;
}

.view {
  font-size: 1.2rem;
}

.arrow {
  line-height: 0.25rem;
}

@media only screen and (max-width: 768px) {
  .destination-wrapper {
    padding: 0;
    width: 100%;
  }

  .destination-wrapper >>> .carousel-control-next-icon:before {
    content: '\e903';
    font-family: 'icomoon';
    font-size: 2.5rem;
  }

  .destination-wrapper >>> .carousel-control-prev-icon:before {
    content: '\e902';
    font-family: 'icomoon';
    font-size: 2.5rem;
  }

  .destination-wrapper >>> .carousel-item img {
    padding-bottom: 210px;
  }

  .destination-wrapper >>> .carousel-indicators {
    bottom: 270px;
  }

  .destination-wrapper >>> .carousel-control-prev,
  .destination-wrapper >>> .carousel-control-next {
    margin-bottom: 250px;
    width: 30px;
  }
}
</style>
